module.exports = __webpack_public_path__ + "static/media/eight25_logo_white.cb5dcc59.svg";